import { API_SLOW_THRESHOLD } from "./analyticsConstant";

class ApiMetricsManager {
  private total = 0;
  private failed = 0;
  private totalDuration = 0;
  private slow = 0;

  startNewPage() {
    this.total = 0;
    this.failed = 0;
    this.totalDuration = 0;
    this.slow = 0;
  }

  record(duration: number, status: "success" | "failed") {
    this.total++;
    this.totalDuration += duration;

    if (status === "failed") this.failed++;
    if (duration > API_SLOW_THRESHOLD) this.slow++;
  }

  getMetrics() {
    return {
      total: this.total,
      failed: this.failed,
      slow: this.slow,
      avg:
        this.total > 0
          ? Math.round(this.totalDuration / this.total)
          : 0,
    };
  }
}

export const apiMetricsManager = new ApiMetricsManager();
